import { trackEvent as trackClarityEvent } from "./clarity.js"
import { trackEvent as trackGaEvent } from "./googleAnalytics.js"

// Fires the same custom event to both Clarity and GA4 — used for the login
// funnel (favorite_click_logged_out → login_started → login_completed →
// favorite_added) so drop-off between steps is visible in either dashboard.
export function trackEvent(name: string, params?: Record<string, unknown>): void {
  trackClarityEvent(name)
  trackGaEvent(name, params)
}
